<div
  class="box-border"
  [ngClass]="[
    shadowColor,
    shadow,
    padding,
    margin,
    width,
    borderRadius,
    borderStyle,
    borderWidth,
    backgroundColor,
    overflow,
    height,
    maxHeight,
    maxWidth
  ]"
>
  <ng-content />
</div>
